<template>
  <v-list-tile :key="name" @click="onClick" @click.middle.stop="onClick" class="pl-arrow-item header-menu__item">
    <v-list-tile-content class="pl-arrow-item__content">
      <v-list-tile-title v-html="title" class="pl-arrow-item__title" />
    </v-list-tile-content>

    <v-icon class="pl-arrow-item__arrow"> keyboard_arrow_right </v-icon>
  </v-list-tile>
</template>
<script>
export default {
  name: 'ArrowItem',
  props: {
    name: {
      type: String,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>
